import { Box, Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

import { Avatar } from "../../Avatar";

interface IDropdownProps {
  avatar: string;
  callback: (arg0: string) => void;
  username: string;
}

const DropdownItem = ({ avatar, callback, username }: IDropdownProps) => (
  <Item onClick={() => callback(username)}>
    <Flex alignItems="center" style={{ gap: 10 }}>
      <Avatar image={avatar} size="tiny" />
      <Text color="ice" fontSize={16} fontWeight={500}>
        {username}
      </Text>
    </Flex>
  </Item>
);

const Item = styled(Box)`
  border-radius: 12px;
  cursor: pointer;
  padding: 10px 16px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray850};
  }
`;

export { DropdownItem };
